<mat-nav-list
  cdkDropList
  [cdkDropListOrientation]="'vertical'"
  (cdkDropListDropped)="onDropped($event)"
  [cdkDropListDisabled]="!draggableList"
>
  <ng-container *ngFor="let floor of floors; trackBy: trackFloor">
    <mat-list-item
      cdkDrag
      class="floor-item"
      [cdkDragLockAxis]="'y'"
      [class.focused]="floor.id === focusedFloor?.id"
      (click)="toggleFloor(floor)"
    >
      <sn-icon *ngIf="draggableList" matListIcon cdkDragHandle (touchmove)="$event.preventDefault()"
        >drag_indicator</sn-icon
      >

      <span matLine>{{ floor.name }}</span>
      <div matLine *ngIf="floor.floorPlanPending">
        <mat-chip
          outlined
          size="xs"
          class="pending-status"
          [label]="'locations.floors.labels.floorPlanPending' | t"
        ></mat-chip>
      </div>

      <sn-icon-button
        *ngIf="actions?.length"
        [matMenuTriggerFor]="menu"
        [matMenuTriggerData]="{ item: floor }"
        (click)="$event.stopPropagation()"
      >
        <sn-icon>more_vert</sn-icon>
      </sn-icon-button>
    </mat-list-item>
    <mat-divider></mat-divider>
  </ng-container>
</mat-nav-list>

<mat-menu #menu="matMenu" xPosition="before">
  <ng-template matMenuContent let-item="item">
    <sn-menu [items]="actions" [context]="item"></sn-menu>
  </ng-template>
</mat-menu>
